<template>
  <v-dialog v-model="dialogValue" max-width="300px">
    <v-card>
      <v-color-picker mode="hexa" hide-mode-switch v-model="novaCor" />
      <div class="card__actions">
        <v-btn class="ma-5 mt-0" color="success" @click="selecionarCor()">
          <v-icon left>mdi-content-save</v-icon>
          Selecionar cor
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    cor: String,
  },
  data: () => ({
    novaCor: "#FFFFFF",
  }),
  computed: {
    dialogValue: {
      get() {
        return this.dialog;
      },
      set() {
        this.dialogClose();
      },
    },
  },
  methods: {
    dialogClose() {
      this.$emit("dialogClose");
    },
    selecionarCor(){
        this.$emit("setCor", this.novaCor)
        this.dialogClose()
    }
  },
  watch:{
    dialog() {
      if (this.dialog) this.novaCor = this.cor
    },
  }
};
</script>

<style scoped>
.card__actions{
    display: flex;
    justify-content: center;
}
</style>

